import axiosClient from './axiosClient';
import { Notification, PagedResponse } from '@/types/common';

export const notificationApi = {
  getAll: async (params?: {
    page?: number;
    size?: number;
    unreadOnly?: boolean;
  }): Promise<PagedResponse<Notification>> => {
    const response = await axiosClient.get('/notifications', { params });
    return response.data;
  },

  getUnreadCount: async (): Promise<number> => {
    const response = await axiosClient.get('/notifications/unread-count');
    return response.data.count;
  },

  markAsRead: async (id: string): Promise<void> => {
    await axiosClient.put(`/notifications/${id}/read`);
  },

  markAllAsRead: async (): Promise<void> => {
    await axiosClient.put('/notifications/read-all');
  },

  delete: async (id: string): Promise<void> => {
    await axiosClient.delete(`/notifications/${id}`);
  },
};
